// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3ZM_O","unreadBadge":"styles_unreadBadge__3GD9e","modalContent":"styles_modalContent__28_oI","modal":"styles_modal__AL7QX"};